







import Vue from 'vue';
import CardInfo from '@/components/card/CardInfo.vue';
import { Component, Prop } from 'vue-property-decorator';
import { PokemonTCG } from 'pokemon-tcg-sdk-typescript';

@Component
export default class CardImage extends Vue {
  @Prop() public src!: string;
}
